import Button from "../component-assets/Button.jsx";
import {useState} from "react";
import ApiRequester from "../ApiRequester.jsx";
import dklogo from "../../img/PCLC.svg";
import {Link} from 'react-router-dom';

const LoginForm = (props) => {

    const [formObj, setForm] = useState({
        username: "",
        password: "",
        errMsg: "",
        attempts: 0
    })

    function loginSubmit(){
        document.getElementById("loadSubmit").classList.remove("d-none");
        document.getElementById("subBtn").classList.add("d-none");
        ApiRequester({username: formObj.username, password: formObj.password,
                                setMsg: {setForm}, attempts: formObj.attempts, reqEndpoint: "login"});
    }

    return formObj.attempts < 5 ? (
        <div className={"row justify-content-center"}>
            <div className={"col-12 col-md-5 col-xl-4 my-5"}>
                <img src={dklogo} alt={"Palcare Logo Colored Varient"} className={"mb-3 w-100"} />
                <form>
                    <div className={"form-floating mb-4 text-secondary"} style={{textAlign:"left"}}>
                        <input id={"Username"} type={"text"} name={"Username"} className={"form-control"} tabIndex={"0"}
                               onChange={e => {
                                    const userEntered = e.target.value;
                                    setForm(prevState => {
                                       return {...prevState, username: userEntered}
                                    });
                        }}/>
                        <label htmlFor={"Username"}>Username</label>
                    </div>
                    <div className={"form-floating mb-4 text-secondary input-group"}>
                        <input type={"password"} name={"Password"} id={"Password"} className={"form-control"} style={{borderRight: "0px"}}
                               onBlur={() => {
                                   const el = document.getElementById("passwordEye");
                                   el.style.backgroundColor = "var(--color-bg-input)";
                                   el.style.borderTopColor = "var(--color-border-input)";
                                   el.style.borderRightColor = "var(--color-border-input)";
                                   el.style.borderBottomColor = "var(--color-border-input)";
                               }}
                               onFocus={() => {
                                   const el = document.getElementById("passwordEye");
                                   el.style.backgroundColor = "var(--color-bg-secondary)";
                                   el.style.borderTopColor = "var(--color-border-focus)";
                                   el.style.borderRightColor = "var(--color-border-focus)";
                                   el.style.borderBottomColor = "var(--color-border-focus)";
                               }}
                               onChange={e => {
                            const passEntered = e.target.value;
                            setForm(prevState => {
                               return {...prevState, password: passEntered}
                            })
                        }} onKeyUp={e => {
                            if (e.key === "Enter"){
                                document.getElementById("subBtn").click();
                            }
                        }}/>
                        <label htmlFor={"Password"} style={{zIndex: "var(--z-dropdown)"}}>Password</label>
                        <span className={"fe fe-eye-off toggle-password input-group-text fs-2"} id={"passwordEye"}
                              style={{backgroundColor: "var(--color-bg-input)", borderTop: "1px solid var(--color-border-input)",
                                        borderRight: "1px solid var(--color-border-input)", borderBottom: "1px solid var(--color-border-input)", borderLeft: "0px",
                                        transition: "background-color var(--transition-fast), border-color var(--transition-fast)"}}
                              onClick={() => {
                                let eyeIcon, passfield;
                                eyeIcon = document.getElementById("passwordEye");
                                passfield = document.getElementById("Password");
                                if (eyeIcon.classList.contains("fe-eye-off")){
                                    eyeIcon.classList.remove("fe-eye-off");
                                    eyeIcon.classList.add("fe-eye");
                                    passfield.type = "text";
                                }else{
                                    eyeIcon.classList.add("fe-eye-off");
                                    eyeIcon.classList.remove("fe-eye");
                                    passfield.type = "password";
                                }
                        }}></span>
                    </div>
                    <Button type={"button"} class={"btn btn-lg w-100 btn-primary d-none mb-3"} disabled={true} spinner={true} text={""} id={"loadSubmit"}/>
                    <Button text={"Login"} type={"button"} class={"btn btn-lg w-100 btn-primary mb-3"} id={"subBtn"}
                            onClick={() => loginSubmit()}/>
                    <div className={"text-center"}>
                        <h5 style={{color: "var(--color-danger)"}}>{formObj.errMsg}</h5>
                    </div>
                    <Link to={"/recovery"}>Forgot Password?</Link>
                </form>
            </div>
        </div>
    ) : <div className={"row justify-content-center"}>
            <div className={"col-12 col-md-5 col-xl-4 my-5"}>
                <img src={dklogo} alt={"Palcare Logo Colored Varient"} className={"mb-3 w-100"} />
                <h3 style={{color: "var(--color-danger)"}}>Maximum login attempts exceeded. Contact your administrator</h3>
            </div>
            <Link to={"/recovery"}>Forgot Password?</Link>
        </div>
};

export default LoginForm;
